<template>
  <div class="page-wrapper">
    
    <div ref="managerForm" class="w-80 mx-auto custom-form">
        <h5 class="form-title">Add an Office</h5>
        <b-form class="row manager-form">
            <b-form-group  class="my-1 col-6">
                <b-form-input
                    type="text"
                    placeholder="Office Name"
                    v-model="form.OfficeName"
                    required />
            </b-form-group>
            <b-form-group class="my-1 col-6">
                <b-form-input
                    type="text"
                    placeholder="Street Address"
                    v-model="form.StreetAddress"/>
            </b-form-group>
            <b-form-group class="my-1 col-6">
                <b-form-input
                    type="text"
                    placeholder="City"
                    v-model="form.City"/>
            </b-form-group>
            <b-form-group class="my-1 col-6 addOfficeCustom">
                <!-- <b-form-select 
                    v-model="form.State" 
                    :options="stateList" 
                    class="custom-coutry-dropdown"
                    placeholder="State"
                    >
                </b-form-select> -->
                <b-form-select class="custom-coutry-dropdown" placeholder="State" v-model="form.State" >
                    <b-form-select-option-group label="United States">
                        <b-form-select-option :key="uof" :value="uof" v-for="uof in stateList">{{uof}}</b-form-select-option>
                    </b-form-select-option-group>
                    <b-form-select-option-group label="Canada">
                        <b-form-select-option :key="uof" :value="uof" v-for="uof in canadaList">{{uof}}</b-form-select-option>
                    </b-form-select-option-group>
                </b-form-select>
                <b-form-input 
                    v-model="form.ZipCode"
                    placeholder="Postal Code"
                    type="text"
                    autocomplete="nope"
                    maxlength="7"
                    @keydown="isCheckPostalCode($event)"
                    required />
            </b-form-group>
            <b-form-group class="my-1 col-6 send-to custom-accordion">
                <multiselect 
                    v-model="selectedManagerValue" 
                    tag-placeholder="" 
                    placeholder="Select Manager" 
                    :options="getManagerList" 
                    :multiple="false" 
                    :taggable="false" 
                    :hideSelected="true"
                    :showLabels='false'>
                </multiselect>
            </b-form-group>
        </b-form>
        <b-button-group class="px-3 w-100 submit-form-btn">
            <b-button variant="outline-primary" @click="saveOfficeInfo">Save</b-button>
        </b-button-group>
    </div>

    <b-table v-if="user.Offices" :items="pagedItems" :fields="fields" striped responsive="sm">
        <!-- <template #cell(name)="row">
            {{ row.item.MgrFirst }} {{ row.item.MgrLast }}
        </template> -->
        <template #cell(Action)="row">
            <b-button style="width: 50%;float: left;" variant="outline" @click="editOfficeDetail(row.item)">
                <v-icon class="text-blue" name="edit" />
            </b-button>
            <b-button style="width: 50%;float: left;" variant="outline" @click="removeOffice(row.item)">
                <v-icon class="text-blue" name="times" />
            </b-button>
        </template>
    </b-table> 

    <b-pagination
    v-model="currentPage"
    :total-rows="getOfficeList.length"
    :per-page="perPage"
    align="center"
    class="my-4"
    ></b-pagination>
    <!--<b-table-simple  v-if="user.Offices" striped responsive hover class="mx-auto text-center middle-grid-sc">
        <b-thead head-variant="light">
            <b-tr class="text-center">
                <b-th><span>Action</span></b-th>
                <b-th><span>Office Name</span></b-th>
                <b-th><span>Manager Name</span></b-th>
                <b-th><span>Street Address</span></b-th>
                <b-th><span>City</span></b-th>
                <b-th><span>State</span></b-th>
                <b-th><span>Postal Code</span></b-th>
            </b-tr>
        </b-thead>
        <b-tbody>
            <b-tr :key="uof.OfficeId" v-for="uof in user.Offices">
                <b-td style="width: 150px;">
                    <b-button style="width: 50%;float: left;" variant="outline" @click="editOfficeDetail(uof)">
                        <v-icon class="text-blue" name="edit" />
                    </b-button>
                    <b-button style="width: 50%;float: left;" variant="outline" @click="removeOffice(uof)">
                        <v-icon class="text-blue" name="times" />
                    </b-button>
                </b-td>
                <b-td style="width: 150px;">{{uof.OfficeName}}</b-td>
                <b-td style="width: 150px;">{{uof.MgrFirst}} {{uof.MgrLast}}</b-td>
                <b-td style="width: 150px;">{{uof.StreetAddress}}</b-td>
                <b-td style="width: 150px;">{{uof.City}}</b-td>
                <b-td style="width: 150px;">{{uof.State}}</b-td>
                <b-td style="width: 150px;">{{uof.ZipCode}}</b-td>
            </b-tr>
        </b-tbody>
    </b-table-simple>-->
    
  </div>
  
</template>

<script>
	import { db } from 'src/db'
	import { mapState } from 'vuex'
    import states from "../../../../public/states.json";
    import canada from "../../../../public/canada.json";
    import Multiselect from 'vue-multiselect'

    import axios from "axios";
	export default {
		name: "Offices",
        components: {
			Multiselect,
		},
		computed: {
            pagedItems() {
                const start = (this.currentPage - 1) * this.perPage;
                const end = start + this.perPage;
                return this.getOfficeList.slice(start, end);
            },
            getManagerList() {
				let Managers = [];
				for (let p of this.user.Managers) {
					if (p.First) {
						Managers.push(p.First+' '+p.Last)
					}
				}
				return Managers
			},
            stateList() {
				return states.States.map((item) => {
					return item.abbreviation;
				})
			},
            canadaList() {
                return canada.States.map((item) => {
					return item.abbreviation;
				})
			},
            getOfficeList() {
                let offices = [];
                Object.assign(offices,this.user.Offices);
                offices.forEach(element => {
                    element.ManagerName = element.MgrFirst && element.MgrLast ?  element.MgrFirst + " " + element.MgrLast : ''
                });
                return offices;
            },
			...mapState('firebase', ['user', 'prospects', 'campaigns'])
		},
		methods: {
            // ALLOW ONLY LETTERS, DIGITS AND WHITE SPACE //
            isCheckPostalCode(e) {
                var value =  e.target.value;
                if (!e.key.match(/[a-zA-Z0-9 -]/) || (e.key == ' ' && value[value.length-1] == ' ')) {
                    e.preventDefault();  
                }
            },
            zipCodeOnKeyDown(event) {
				if (this.form.ZipCode.length >= 5) {
					if (event.key == '0' || event.key == '1' || 
						event.key == '2' || event.key == '3' || 
						event.key == '4' || event.key == '5' || 
						event.key == '6' || event.key == '7' ||
						event.key == '8' || event.key == '9') 
					{
						event.preventDefault();
					}
				}
			},
            async getProspectAddressZipcodeDetails(StreetAddress, City, State, ZipCode) {
                var mergeAddress = StreetAddress+' '+City+' '+State+' '+ZipCode;
                var ConvertmergeAddress = mergeAddress.replace(/\s+/g, '+'); // CONVERT WHITE SPACE TO PLUS
                await axios.get("https://maps.googleapis.com/maps/api/geocode/json?address="+ConvertmergeAddress+"&key=AIzaSyDB3iBxxzF9leRLy4mihVjBCAwWFenuuuA")
				.then(response => {
					//eslint-disable-next-line
					//console.log('getProspectAddressZipcodeDetails:', response);
                    this.AddresszipCodeDetails = response;
                });
            },
            async getProspectZipcodeDetails(zipcode) {
				await axios.get("https://app.zipcodebase.com/api/v1/search?apikey=cdbfa120-2941-11ef-825e-45214465aa92&codes="+zipcode+"&country=us")
				.then(response => {
					//eslint-disable-next-line
					console.log(response);
                    this.zipCodeDetails = response;
				});
			},
            async saveOfficeInfo() {
                if(this.selectedManagerValue != '') {
                    let Mdata = this.user.Managers.find(et => et.First+' '+et.Last == this.selectedManagerValue)
                    var MgrID = (Mdata && Mdata.MgrID) || '';
                    var MgrFirst = (Mdata && Mdata.First) || '';
                    var MgrLast = (Mdata && Mdata.Last) || '';
                } 
                if (this.form.OfficeName && this.form.StreetAddress && this.form.City && this.form.State && this.form.ZipCode) {
                    let newAddedOffice = [];
                    await this.getProspectAddressZipcodeDetails(this.form.StreetAddress, this.form.City, this.form.State, this.form.ZipCode)
                    //eslint-disable-next-line
                    //console.log('AddresszipCodeDetails:', this.AddresszipCodeDetails); // Details
                    let lat = '';
                    let lng = '';
                    if(this.AddresszipCodeDetails.data.status == 'OK') { // ZERO_RESULTS
                        if (this.AddresszipCodeDetails) {
                            lat = this.AddresszipCodeDetails.data.results[0].geometry.location.lat;
                            lng = this.AddresszipCodeDetails.data.results[0].geometry.location.lng;
                        }
                    } else {
                        var postalcodeData = this.form.ZipCode;
                        var mergeAddress = postalcodeData;
                        var ConvertmergeAddress = mergeAddress.replace(/\s+/g, '+'); // CONVERT WHITE SPACE TO PLUS
                        await axios.get("https://maps.googleapis.com/maps/api/geocode/json?address="+ConvertmergeAddress+"&key=AIzaSyDB3iBxxzF9leRLy4mihVjBCAwWFenuuuA")
                        .then(response => {
                            this.AddresszipCodeDetails = response;
                            lat = this.AddresszipCodeDetails.data.results[0].geometry.location.lat;
                            lng = this.AddresszipCodeDetails.data.results[0].geometry.location.lng;
                            //eslint-disable-next-line
                            console.log("lng",lat,lng);
                        });
                        // var sendPayload = {
                        //     postalcode: this.form.ZipCode,
                        //     Uid: this.user.Uid,
                        // }   
                        // axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/closestOffice", sendPayload)
                // .then(async(response) => { 
                        //         if(response.data.type === 'success') {
                        //             lng = response.data.data.officeData.longitude;
                        //             lat = response.data.data.officeData.latitude;
                        //             if(lat == '' || lng == '') {
                        //                 var mergeAddress = postalcodeData;
                        //                 var ConvertmergeAddress = mergeAddress.replace(/\s+/g, '+'); // CONVERT WHITE SPACE TO PLUS
                        //                 await axios.get("https://maps.googleapis.com/maps/api/geocode/json?address="+ConvertmergeAddress+"&key=AIzaSyDB3iBxxzF9leRLy4mihVjBCAwWFenuuuA")
                        //                 .then(response => {
                        //                     this.AddresszipCodeDetails = response;
                        //                     lat = this.AddresszipCodeDetails.data.results[0].geometry.location.lat;
                        //                     lng = this.AddresszipCodeDetails.data.results[0].geometry.location.lng;
                        //                     //eslint-disable-next-line
                        //                     console.log("lng",lat,lng);
                        //                 });
                        //             }else{
                        //                 // lat = '';
                        //                 // lng = '';
                        //             }
                        //         }else{
                        //             // lat = '';
                        //             // lng = '';
                        //         }
                        //     }
                        // )
                        // lat = '';
                        // lng = '';
                    }
                    /*
                    await this.getProspectZipcodeDetails(this.form.ZipCode);
                    //eslint-disable-next-line
                    console.log(this.zipCodeDetails);
                    let lat = '';
                    let lng = '';
                    if (this.zipCodeDetails) {
                        lat = this.zipCodeDetails.data.results[this.form.ZipCode][0].latitude;
                        lng = this.zipCodeDetails.data.results[this.form.ZipCode][0].longitude;
                    }
                    */
                    //eslint-disable-next-line
                    console.log(lat,lng);
                    if (this.user.Offices) {
                        newAddedOffice = this.user.Offices;
                        if (this.form.OfficeId) {
                            for(let no of newAddedOffice) {
                                if (this.form.OfficeId == no.OfficeId) {
                                    no.StreetAddress = this.form.StreetAddress;
                                    no.City = this.form.City;
                                    no.State = this.form.State;
                                    no.ZipCode = this.form.ZipCode;
                                    no.OfficeName = this.form.OfficeName;
                                    if(this.selectedManagerValue != '') {
                                        no.MgrID = MgrID;
                                        no.MgrFirst = MgrFirst;
                                        no.MgrLast = MgrLast;
                                    }
                                    no.latitude = lat;
                                    no.longitude = lng;
                                    break;
                                }
                            }
                        } else {
                            // ADD NEW
                            if(this.selectedManagerValue != '') {
                                newAddedOffice.push({
                                    StreetAddress:this.form.StreetAddress,
                                    City:this.form.City,
                                    State:this.form.State,
                                    ZipCode:this.form.ZipCode,
                                    OfficeName:this.form.OfficeName,
                                    MgrID:MgrID,
                                    MgrFirst:MgrFirst,
                                    MgrLast:MgrLast,
                                    OfficeId:this.getUniqueOfficeID(),
                                    latitude:lat,
                                    longitude:lng
                                });
                            } else {
                                newAddedOffice.push({
                                    StreetAddress:this.form.StreetAddress,
                                    City:this.form.City,
                                    State:this.form.State,
                                    ZipCode:this.form.ZipCode,
                                    OfficeName:this.form.OfficeName,
                                    OfficeId:this.getUniqueOfficeID(),
                                    latitude:lat,
                                    longitude:lng
                                });
                            }
                        }
                    }else {
                        newAddedOffice.push({
                            StreetAddress:this.form.StreetAddress,
                            City:this.form.City,
                            State:this.form.State,
                            ZipCode:this.form.ZipCode,
                            OfficeName:this.form.OfficeName,
                            OfficeId:this.getUniqueOfficeID()
                        });
                    }
                    this.form.StreetAddress = '';
                    this.form.City = '';
                    this.form.State = '';
                    this.form.ZipCode = '';
                    this.form.OfficeName = '';
                    this.form.OfficeId = '';
                    this.selectedManagerValue = '';
                    db.doc(`Users/${this.user.id}`).update({ Offices: newAddedOffice});
                }else {
                    alert("Plese fill all the fields details");
                }
            },
            getUniqueOfficeID() {
                let did = (Math.floor(Math.random()*(100000-1+1)+1));
                if (this.user.Offices) {
                    let um = this.user.Offices.find(m => m.OfficeId == did);
                    if (um) {
                        this.getUniqueOfficeID();
                    }
                }
                return did;
            },
            editOfficeDetail(md) {
                this.$refs.managerForm.scrollIntoView({ block: 'end', scrollBehavior: 'smooth' });
                this.form.StreetAddress = md.StreetAddress;
                this.form.City = md.City;
                this.form.State = md.State;
                this.form.ZipCode = md.ZipCode;
                this.form.OfficeName = md.OfficeName;
                this.form.OfficeId = md.OfficeId;
                this.selectedManagerValue = md.MgrFirst+' '+md.MgrLast;
                if(this.selectedManagerValue == 'undefined undefined') { this.selectedManagerValue = ''; }
            },
            removeOffice(od) {
				if (confirm("Are you sure you want to delete this Office?")) {
                    let i=0;
                    let Offices = this.user.Offices
					for (let o of Offices) {
						if (od.OfficeId == o.OfficeId) {
							Offices.splice(i,1)
						}
						i++;
                    }
					db.doc(`Users/${this.user.id}`).update({Offices:Offices});
                }
			},
		},
        data() {
			return {
                form: {
                    StreetAddress: '',
                    City:'',
                    State:'',
                    ZipCode:'',
                    OfficeName:'',
                    OfficeId :''
                },
                fields: [
                    'Action',
                    {'key':'OfficeName',sortable: true}, 
                    {'key':'ManagerName', label: 'Manager Name', sortable: true}, 
                    {'key':'StreetAddress',sortable: true}, 
                    {'key':'City',sortable: true},
                    {'key':'State',sortable: true},
                    {'key':'ZipCode',sortable: true}
                    ],
                zipCodeDetails:{},
                selectedManagerValue:[],
                currentPage: 1,
                perPage: 10,
            }
        }
        // {key:'Twilio',label: 'taTEXT Number',}
    }
</script>

<style scoped>
.addOfficeCustom > div {
    display: flex !important;
}
.addOfficeCustom .bv-no-focus-ring input {
    padding: 11px 15px;
    height: 100%;
    display: inline-block !important;
    width: calc(100% - 140px) !important;
}
.addOfficeCustom .custom-coutry-dropdown.custom-select {
    width: 70px !important;
    height: 42px;
    margin-right: 7px;
    float: left !important;
    display: inline-block !important;
}
	.btn-group button.btn.btn-outline-primary{       
        background: #042b79;
        color: #fff;
        border-color: #042b79;
    }
    .date_picker_add b-form-datepicker{
        top:160px;
    }
    .page-wrapper{
        height: 100vh;overflow-x: hidden;overflow-y: auto;
    }
    .submit-form-btn.btn-group > button {
    padding: 5px 30px;
}
.submit-form-btn.btn-group {
    /* max-width: 100px; */
    text-align: center;
    /* margin-right: 0; */
    width: 100%;
    /* text-align: end; */
    display: inline-block;
    padding: 0 !important;
    margin-top: 10px;
    margin-bottom: 10px;
}
.custom-form{
    margin-bottom: 30px;
    background: rgb(242 242 242 / 30%);
    padding: 20px;
    box-shadow: 0px 0px 4px 0px #d3cfcf;
    border-radius: 3px;
    /* border: 1px solid #ccc; */
    width: 90%;
}
.bv-no-focus-ring input {
    padding: 11px 15px;
    height: 100%;
}
form.row.manager-form {
    margin: 0px -5px !important;
}
form.row.manager-form > div{
    padding: 0px 5px !important;
}
.form-title{
    width: 100%;text-align: center;display: inline-block;
}
.addOfficeCustom .custom-coutry-dropdown.custom-select {
    width: 130px !important;
    height: 42px;
    margin-right: 7px;
}


</style>